/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Field_Payout_BicInputs */



/**
* | output |
* | --- |
* | "Payout BIC" |
*
* @param {Partner_Admin_Field_Payout_BicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_field_payout_bic = /** @type {((inputs?: Partner_Admin_Field_Payout_BicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Field_Payout_BicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auszahlungs-BIC")
	return /** @type {LocalizedString} */ ("Payout BIC")
});